import { PageHero } from "@/components/PageHero";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { Eye, Compass, Gem, Leaf, Lightbulb } from "lucide-react";
import { IMG } from "@/data/site";

const values = [
  { icon: Gem, title: "Service Excellence", text: "Exceeding expectations with anticipatory, personalised care for every guest." },
  { icon: Compass, title: "Authenticity & Heritage", text: "Honouring Tanzanian cultural roots to create genuine, immersive experiences." },
  { icon: Leaf, title: "Sustainability & Responsibility", text: "Committed to environmental stewardship and empowering our local community." },
  { icon: Lightbulb, title: "Continuous Innovation", text: "Embracing forward-thinking solutions for a dynamic future in hospitality." },
  { icon: Eye, title: "Integrity & Transparency", text: "Upholding ethical standards with honesty and openness in all our actions." },
];

export default function VisionMission() {
  return (
    <div data-testid="vision-mission-page">
      <PageHero overline="Vision & Mission" title="Why we exist" image={IMG.coastAerial} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          <FadeUp className="bg-[#121212] border hairline p-10 md:p-14">
            <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">Our Vision</p>
            <p className="font-serif-display text-2xl md:text-3xl font-light text-white leading-snug">
              To be the leading destination for luxury hospitality in Africa — blending modern sophistication with authentic Tanzanian cultural heritage.
            </p>
          </FadeUp>
          <FadeUp delay={0.1} className="bg-[#121212] border hairline p-10 md:p-14">
            <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">Our Mission</p>
            <p className="font-serif-display text-2xl md:text-3xl font-light text-white leading-snug">
              To deliver personalised, unique experiences for every guest — with world-class service, environmental sustainability and community support at our core.
            </p>
          </FadeUp>
        </div>
        <Stagger className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((v) => (
            <StaggerItem key={v.title} className="border-t-2 border-[#d4af37]/40 pt-8">
              <v.icon className="text-[#d4af37] mb-4" size={26} />
              <h3 className="font-serif-display text-2xl font-light text-white">{v.title}</h3>
              <p className="mt-3 text-sm text-[#a3a3a3] leading-relaxed">{v.text}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
